<template>
  <div style="margin:20px">
    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Summary Dashboard</span><br/>
      <span style="font-style: italic; font-size: 18px">summary of stats across all companies</span>
    </div>

    <div style="position: relative" class="align-right d-flex align-items-center justify-content-center">
      <a href="#" class="arrows" v-on:click.prevent="shift_detail_graph_date(-1)"><</a>
      &nbsp;&nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"></date-picker>&nbsp;&nbsp;
      <a href="#" class="arrows" v-on:click.prevent="shift_detail_graph_date(1)">></a>
      <span v-if="admin_mode" style="font-size: 20px; font-weight: bold" class="align-right d-flex align-items-center justify-content-center">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        Tenant Filter:&nbsp;&nbsp;<b-form-input style="width: 200px" v-model="tenant_filter"/>&nbsp;<b-button v-on:click.prevent="load_data()">Run</b-button>
      </span>
    </div>
    <div style="margin: 20px;" v-if="!loading && summary">
      <div class="row-none" style="font-weight: bold; font-size: 20px;">
        <div class="col" style="font-size: 20px; min-width: 250px; max-width: 250px; color: white; background-color: var(--fi-rail-accent)" v-on:click="toggle_div(toggle,'isTenantStatsVisible')">Overview</div>
        <div class="col" style="border: 1px solid grey;">Tenants: {{summary.tenant_count}}</div>
        <div class="col" style="border: 1px solid grey;">Vehicles: {{summary.vehicle_count}}</div>
        <div class="col" style="border: 1px solid grey;">Drivers: {{summary.driver_count}}</div>
      </div>
      <div :style="toggle.isTenantStatsVisible ? 'margin:30px;' : 'display:none'">
        <template v-for="tenant_stat in summary.tenant_stats">
          <div class="row" style="font-weight: bold; font-size: 18px;">
            <div class="col" style="border: 1px solid grey;">{{tenant_stat.tenant_name}}</div>
            <div class="col" style="border: 1px solid grey;">Vehicles: {{tenant_stat.vehicle_count}}</div>
            <div class="col" style="border: 1px solid grey;">Drivers: {{tenant_stat.driver_count}}</div>
          </div>
        </template>
      </div>
      <br/>
      <div class="row-none" style="font-weight: bold; font-size: 18px;" v-if="summary.actuals_totals">
        <div class="col" style="font-size: 20px; min-width: 250px; max-width: 250px; color: white; background-color: var(--fi-rail-accent)" v-on:click="toggle_div(toggle,'isActualsTenantStatsVisible')">Monthly Actuals Totals</div>
        <div class="col" style="border: 1px solid grey;">Total: {{summary.actuals_totals.total_cnt}}</div>
        <div class="col" style="border: 1px solid grey;">Success: {{summary.actuals_totals.success_cnt}}</div>
        <div class="col" style="border: 1px solid grey;">Error: {{summary.actuals_totals.error_cnt}}</div>
        <div class="col" style="border: 1px solid grey;">Cancelled: {{summary.actuals_totals.cancelled_cnt}}</div>
        <div class="col" style="border: 1px solid grey;">Unprocessed: {{summary.actuals_totals.unprocessed_cnt}}</div>
      </div>
      <div :style="toggle.isActualsTenantStatsVisible ? 'margin:30px;' : 'display:none'">
        <template v-for="tenant_stat in summary.tenant_stats">
          <div class="row" style="font-weight: bold; font-size: 18px;">
            <div class="col" style="border: 1px solid grey;">{{tenant_stat.tenant_name}}</div>
            <div class="col" style="border: 1px solid grey;">Total: {{tenant_stat.actuals_totals.total_cnt}}</div>
            <div class="col" style="border: 1px solid grey;">Success: {{tenant_stat.actuals_totals.success_cnt}}</div>
            <div class="col" style="border: 1px solid grey;">Error: {{tenant_stat.actuals_totals.error_cnt}}</div>
            <div class="col" style="border: 1px solid grey;">Cancelled: {{tenant_stat.actuals_totals.cancelled_cnt}}</div>
            <div class="col" style="border: 1px solid grey;">Unprocessed: {{tenant_stat.actuals_totals.unprocessed_cnt}}</div>
          </div>
        </template>
      </div>
      <br/>
      <div class="row-none" style="font-weight: bold; font-size: 18px;" v-if="summary.alert_totals">
        <div class="col" style="font-size: 20px; min-width: 250px; max-width: 250px; color: white; background-color: var(--fi-rail-accent)" v-on:click="toggle_div(toggle,'isAlertTenantStatsVisible')">Monthly Alert Totals</div>
        <div class="col" style="border: 1px solid grey;">Alerts: {{summary.alert_totals.alert_cnt}}</div>
        <div class="col" style="border: 1px solid grey;">Late Alerts: {{summary.alert_totals.late_alert_cnt}}</div>
        <div class="col" style="border: 1px solid grey;">Trip Alerts: {{summary.alert_totals.trip_notification_cnt}}</div>
        <div class="col" style="border: 1px solid grey;">Emails: {{summary.alert_totals.email_cnt}}</div>
        <div v-if="summary.alert_totals.msteams_cnt" class="col" style="border: 1px solid grey;">MSTeams Sent: {{summary.alert_totals.msteams_cnt}}</div>
        <div v-if="summary.alert_totals.slack_cnt" class="col" style="border: 1px solid grey;">Slack Sent: {{summary.alert_totals.slack_cnt}}</div>
      </div>
      <div :style="toggle.isAlertTenantStatsVisible ? 'margin:30px;' : 'display:none'">
        <template v-for="tenant_stat in summary.tenant_stats">
          <div class="row" style="font-weight: bold; font-size: 18px;">
            <div class="col" style="border: 1px solid grey;">{{tenant_stat.tenant_name}}</div>
            <div class="col" style="border: 1px solid grey;">Alerts: {{tenant_stat.alert_totals.alert_cnt}}</div>
            <div class="col" style="border: 1px solid grey;">Late Alerts: {{tenant_stat.alert_totals.late_alert_cnt}}</div>
            <div class="col" style="border: 1px solid grey;">Trip Alerts: {{tenant_stat.alert_totals.trip_notification_cnt}}</div>
            <div class="col" style="border: 1px solid grey;">Emails: {{tenant_stat.alert_totals.email_cnt}}</div>
            <div v-if="tenant_stat.alert_totals.msteams_cnt" class="col" style="border: 1px solid grey;">MSTeams Sent: {{tenant_stat.alert_totals.msteams_cnt}}</div>
            <div v-if="tenant_stat.alert_totals.slack_cnt" class="col" style="border: 1px solid grey;">Slack Sent: {{tenant_stat.alert_totals.slack_cnt}}</div>
          </div>
        </template>
      </div>
      <br/>
      <div class="row-none" style="font-weight: bold; font-size: 18px;" v-if="summary.alert_totals && summary.alert_totals.sms_cnt > 0">
        <div class="col" style="font-size: 20px; min-width: 250px; max-width: 250px; color: white; background-color: var(--fi-rail-accent)" v-on:click="toggle_div(toggle,'isSMSTenantStatsVisible')">Monthly SMS Stats</div>
        <div class="col" style="border: 1px solid grey;">Sent Msgs: {{summary.alert_totals.sms_cnt}} ({{ (summary.alert_totals.sms_cnt/summary.alert_totals.alert_cnt) | roundNumber(1)}} #s/msg)</div>
        <div v-if="summary.alert_totals.sms_cost && summary.alert_totals.sms_cost > 0" class="col" style="border: 1px solid grey;">Sent Units: {{summary.alert_totals.sms_unit_cnt}} ({{ (summary.alert_totals.sms_unit_cnt/summary.alert_totals.sms_cnt) | roundNumber(1)}}/msg)</div>
        <div v-if="summary.alert_totals.sms_cost && summary.alert_totals.sms_cost > 0" class="col" style="border: 1px solid grey;">Sent Cost: ${{summary.alert_totals.sms_cost}} (${{ (summary.alert_totals.sms_cost/summary.alert_totals.sms_cnt) | roundNumber(3)}}/msg)</div>
        <div v-if="summary.alert_totals.sms_inbound_cnt && summary.alert_totals.sms_inbound_cnt > 0" class="col" style="border: 1px solid grey;">Received Count: {{summary.alert_totals.sms_inbound_cnt}}</div>
        <div v-if="summary.alert_totals.sms_inbound_cnt && summary.alert_totals.sms_inbound_cnt > 0" class="col" style="border: 1px solid grey;">Received Cost: ${{summary.alert_totals.sms_inbound_cost}}</div>
      </div>
      <div :style="toggle.isSMSTenantStatsVisible ? 'margin:30px;' : 'display:none'">
      <template v-for="tenant_stat in summary.tenant_stats">
        <div class="row" style="font-weight: bold; font-size: 18px;">
          <div class="col" style="border: 1px solid grey;">{{tenant_stat.tenant_name}}</div>
          <div class="col" style="border: 1px solid grey;">SMS Sent Cost: ${{tenant_stat.alert_totals.sms_cost}}</div>
          <div class="col" style="border: 1px solid grey;">SMS Received Cost: ${{tenant_stat.alert_totals.sms_inbound_cost}}</div>
        </div>
      </template>
      </div>

      <dashboard-chart v-if="actuals_chart_data" :loading="loading" :chart_data="actuals_chart_data" chart_type="LineChart"
                       graph_title="Actuals By Date" date_format="MM/dd"
                       graph_height="250"/>

      <dashboard-chart v-if="alerts_chart_data && summary.alert_totals && summary.alert_totals.alert_cnt > 0" :loading="loading" :chart_data="alerts_chart_data" chart_type="LineChart"
                       graph_title="Alerts By Date" date_format="MM/dd"
                       graph_height="250"/>

      <dashboard-chart v-if="booking_files_chart_data" :loading="loading" :chart_data="booking_files_chart_data" chart_type="LineChart"
                       graph_title="Booking Updates By Date" date_format="MM/dd"
                       graph_height="280"/>

    </div>
    <div v-if="loading">
      <br/><br/>
      <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>
  </div>
</template>
<script>
import {get_admin_dashboard} from '../networking/apis'
import {mapState} from "vuex";
import moment from 'moment'
import DashboardChart from './DashboardChart'
import { GChart } from 'vue-google-charts'
import {justDate} from "@/helpers/dates";

export default {
  name: 'admin_dashboard',
  components: {
    DashboardChart,
    GChart
  },

  data() {
    return {
      toggle: {},
      admin_mode: false,
      actuals_chart_data: null,
      alerts_chart_data: null,
      booking_files_chart_data: null,
      tenant_filter: 'AAAHI',
      details_fromDate: justDate(moment().subtract(1, 'days')),
      model: {},
      summary: {},
      loading: false,
      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment().subtract(90, 'days'),
        maxDate: moment().add(90, 'days'),
        keepOpen: false,
        showClear: true,
        showClose: true,
      }
    }
  },
  async created() {
    this.check_features()
  },
  methods: {
    toggle_div(item,field) {
      item[field] = !item[field];
      this.$forceUpdate();
    },
    async check_features() {
      this.admin_mode = this.user.role == 'admin'
    },
    async load_data() {
      this.loading = true
      try {
        const {value: { data = [] } } = await get_admin_dashboard(this.user.tenant,moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),this.tenant_filter)
        this.summary = data

        if (data.stats != null) {
          const daily = data.stats

          this.actuals_chart_data = [
            ['Date', 'Total Processed', 'Error', 'Success', 'Cancelled', 'Unprocessed'],
            ...(data.length !== 0 ? daily : [{date: new Date()}]).map(
                ({date, stats = {}}) => [
                  moment(String(date)).format('MM/DD'), Number(stats.actuals.total_cnt || 0), Number(stats.actuals.error_cnt || 0), Number(stats.actuals.success_cnt || 0), Number(stats.actuals.cancelled_cnt || 0), Number(stats.actuals.unprocessed_cnt || 0)
                ]
            )
          ]

          this.alerts_chart_data = [
            ['Date', 'Total Alerts', 'Late Alerts', 'Trip Notifications', 'Emails', 'SMS', 'Slack', 'MSTeams'],
            ...(data.length !== 0 ? daily : [{date: new Date()}]).map(
                ({date, stats = {}}) => [
                  moment(String(date)).format('MM/DD'), Number(stats.alerts.alert_cnt || 0), Number(stats.alerts.late_alert_cnt || 0), Number(stats.alerts.trip_notification_cnt || 0), Number(stats.alerts.email_cnt || 0), Number(stats.alerts.sms_cnt || 0), Number(stats.alerts.slack_cnt || 0), Number(stats.alerts.msteams_cnt || 0),
                ]
            )
          ]

          this.booking_files_chart_data = [
            ['Date', 'Total Updates', 'Contract Updates', 'Charter Updates'],
            ...(data.length !== 0 ? daily : [{date: new Date()}]).map(
                ({date, stats = {}}) => [
                  moment(String(date)).format('MM/DD'), Number(stats.bookings.booking_update_total_cnt || 0), Number(stats.bookings.booking_update_contract_cnt || 0), Number(stats.bookings.booking_update_private_cnt || 0)
                ]
            )
          ]
        }
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.loading = false
    },
    async shift_detail_graph_date(shift) {
      this.details_fromDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
    }
  } ,
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
  },
  watch: {
    details_fromDate(target_from_date) {
      this.details_fromDate = target_from_date
      this.load_data();
    }
  }
}
</script>
